<div class="cfg">
  <div class="cfg-head">
    <div>
      <h2>Configuración del seguimiento</h2>
      <p class="cfg-sub">
        Define <b>cómo</b> mide el módulo, no si mide: el seguimiento corre siempre.
        Las semanas ya cerradas no cambian — cada una guardó los umbrales con los
        que se pintó.
      </p>
    </div>
    <button mat-icon-button (click)="cerrar()" title="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="cfg-body">
    <div class="cfg-grupo" *ngFor="let g of grupos">
      <div class="cfg-t">{{ g.titulo }}</div>
      <p class="cfg-nota" *ngIf="g.nota">{{ g.nota }}</p>

      <div class="cfg-campos">
        <label *ngFor="let c of g.campos" [class.ancho]="c.tipo === 'texto'">
          <span class="cfg-etq">{{ c.etiqueta }}</span>

          <input
            *ngIf="c.tipo === 'numero'"
            type="number"
            [step]="c.paso ?? 1"
            [min]="c.min ?? null"
            [max]="c.max ?? null"
            [(ngModel)]="c.valor"
          />

          <input *ngIf="c.tipo === 'fecha'" type="date" [(ngModel)]="c.valor" />

          <input *ngIf="c.tipo === 'texto'" type="text" [(ngModel)]="c.valor" />

          <select *ngIf="c.tipo === 'opciones'" [(ngModel)]="c.valor">
            <option *ngFor="let o of c.opciones" [value]="o">{{ o }}</option>
          </select>

          <span class="cfg-ayuda">{{ c.ayuda }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="cfg-pie">
    <button mat-stroked-button (click)="cerrar()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="guardar()" [disabled]="guardando">
      {{ guardando ? 'Guardando…' : 'Guardar' }}
    </button>
  </div>
</div>
